import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../InputForm';
import SelectForm from '../SelectForm';
import SelectMultiForm from '../SelectMultiForm';
import usePreferenciasStore from '../../store/preferenciasStore';

const FormPreferencias = () => {
    const navigate = useNavigate();
    const [disabledButton, setDisabledButton] = useState(false)
    const goBack = () => {
        navigate(-1);
    };

    const { datos, handleChange, handleSave, estatus, sucursales, handleSucursal, error } = usePreferenciasStore();

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <InputForm
                        name="nombre"
                        label="Nombre"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <SelectMultiForm
                        col="col-sm-12"
                        datos={sucursales} 
                        change={handleSucursal}
                        values={datos.sucursales}
                        placeholder="Todas las sucursales"
                        error={error}
                        name="sucursales"
                    />
                    <SelectForm
                        name='estatus'
                        label='Estatus'
                        datos={datos}
                        change={handleChange}
                        options={estatus}
                    />
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <button
                            onClick={goBack}
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                            Cancelar
                        </button>
                        <button
                            // type="submit"
                            disabled={disabledButton}
                            onClick={
                                () => {
                                    // setDisabledButton(true);
                                    handleSave();
                                }
                            }
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FormPreferencias;
